/* tslint:disable */
/* eslint-disable */
/* @relayHash b36b3d923cf47197fbcad76ff7155072 */

import { ConcreteRequest } from "relay-runtime";
export type ShipmentQuoteRequestInput = {
    buyerId: string;
    itemPk?: string | null;
    itemIds?: Array<string | null> | null;
    dealerPk?: string | null;
    message: string;
    subject: string;
    action?: string | null;
    pageContext?: string | null;
    transactionId?: string | null;
    conversationId?: string | null;
    city?: string | null;
    state?: string | null;
    country?: string | null;
    zipCode?: string | null;
    currencyConversionRateEventId?: string | null;
    shippingAddressId?: string | null;
    portfolioIds?: Array<string | null> | null;
    conversationIds?: Array<string | null> | null;
    clientMutationId?: string | null;
};
export type requestShipmentQuoteMutationVariables = {
    input: ShipmentQuoteRequestInput;
};
export type requestShipmentQuoteMutationResponse = {
    readonly shipmentQuoteRequest: {
        readonly conversation: {
            readonly id: string;
            readonly serviceId: string | null;
            readonly transaction: {
                readonly id: string;
                readonly serviceId: string | null;
            } | null;
        } | null;
    } | null;
};
export type requestShipmentQuoteMutation = {
    readonly response: requestShipmentQuoteMutationResponse;
    readonly variables: requestShipmentQuoteMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ShipmentQuoteRequestInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "shipmentQuoteRequest",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ShipmentQuoteRequestPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "conversation",
        "storageKey": null,
        "args": null,
        "concreteType": "Conversation",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "transaction",
            "storageKey": null,
            "args": null,
            "concreteType": "Transaction",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "requestShipmentQuoteMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "requestShipmentQuoteMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "requestShipmentQuoteMutation",
    "id": "app-buyer-finding/295.0.0-2020-12-22T23:44:49.579Z/requestShipmentQuoteMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '0907d83770d95f82e909f436c2af3af8';
export default node;
